<h2 class="heading-4 bold wrap-unset mr-20">
  @switch (data.state) {
    @case ('cancelComplete') {
      You’ve cancelled your repair
    }
    @case ('cancelError') {
      Something’s gone wrong
    }
    @default {
      Tell us why you're cancelling
    }
  }
</h2>

<button class="dialog-close" (click)="dialogRef.close()">
  <i class="fa-light fa-close"></i>
</button>

@switch (data.state) {
  @case ('cancelComplete') {
    <p class="body mt-8 mb-16">Thanks for letting us know. Remember you can come back anytime to rebook your repair.</p>
    <section class="flex gap-8">
      <app-button dataLabel="close" [buttonOptions]="{ fill: true }" (onClick)="dialogRef.close()"> Close </app-button>
    </section>
  }

  @case ('cancelError') {
    <p class="body mt-8">Sorry, there was an error.</p>
    <p class="body">Please try again, or give us a call on:</p>
    <app-telephone-link class="mt-8 mb-8 phone" phoneNumber="0333 000 1415"> </app-telephone-link>
    <p class="hint">
      Calls cost the basic rate per minute plus your phone company’s access charge. From a mobile, they can cost much
      more.
    </p>
    <section class="flex-col full-width gap-12 mt-16">
      <app-button dataLabel="retry" [buttonOptions]="{ variant: 'secondary' }" (onClick)="cancelBooking()">
        Try again to cancel
      </app-button>
      <app-button dataLabel="close" [buttonOptions]="{ fill: true }" (onClick)="dialogRef.close()"> Close </app-button>
    </section>
  }

  @default {
    <section class="reason-list flex flec-col gap-8 mt-20 mb-20" data-testid="cancel-reason-list">
      @for (reason of cancelReasons; track reason; let index = $index) {
        <app-radio-button
          data-testid="cancel-reason"
          class="full-width"
          variant="blue"
          [(ngModel)]="selectedCancelReason"
          [index]="index"
          [optionValue]="reason"
          (ngModelChange)="reason === selectedCancelReason ? null : (showPleaseSelectOptionError = false)"
        >
          <p class="body bold">
            {{ reason }}
          </p>
        </app-radio-button>
      }
    </section>

    <h3 class="heading-5">Sure you want to cancel?</h3>
    <p class="body mt-8 mb-16">
      If so, we'll delete your booking. You'll need to book again if you still need a repair
    </p>

    @if (showPleaseSelectOptionError) {
      <p class="body error mb-16">
        <i class="fa-light fa-circle-exclamation"></i>
        Please select a reason
      </p>
    }

    <section class="flex gap-8">
      <app-button
        dataLabel="go-back"
        [buttonOptions]="{ variant: 'secondary', fill: true }"
        (onClick)="dialogRef.close()"
      >
        Keep repair
      </app-button>
      <app-button dataLabel="yes-button" [buttonOptions]="{ fill: true }" (onClick)="cancelBooking()">
        Cancel repair
      </app-button>
    </section>
  }
}
